<template>
  <div
    ref="kt_modal_faturamento_editar_autorizados"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_autorizados"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Autorizados</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <label for="txtAutorizado" class="form-label"
            >Documento - CPF/CNPJ</label
          >
          <input
            type="text"
            id="txtAutorizado"
            :class="[
              'form-control mb-2',
              errosValidacao['autorizado'] ? 'is-invalid' : '',
            ]"
            v-model="this.documento"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            @keydown.stop.prevent.enter="confirmar()"
            @keydown.stop.prevent.esc="cancelar()"
          />
          <div class="row">
            <div class="col-6 pe-0">
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["autorizado"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loadingAutorizado ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingAutorizado">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";

export default {
  emits: [
    "exibirModalEditarAutorizados",
    "adicionarAutorizado",
    "editarAutorizado",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    autorizado: { type: String, required: true, default: "" },
  },
  methods: {
    confirmar() {
      this.errosValidacao = [];
      this.loadingAutorizado = true;
      if (this.documento.trim() === "") {
        this.errosValidacao = {
          autorizado: "O documento informado é inválido!",
        };
      } else if (this.$utils.validarCPFCNPJ(this.documento) === false) {
        this.errosValidacao = {
          autorizado: "O documento informado é inválido!",
        };
      } else {
        let documentoConfirmado = {
          documento: this.$utils.unMask(this.documento),
        };
        if (this.index === -1) {
          this.$emit("adicionarAutorizado", documentoConfirmado);
        } else {
          this.$emit("editarAutorizado", documentoConfirmado, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_autorizados);
        this.$emit("exibirModalEditarAutorizados", false);
      }
      this.loadingAutorizado = false;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_autorizados);
      this.$emit("exibirModalEditarAutorizados", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.documento = JSON.parse(JSON.stringify(this.autorizado));
    } else {
      this.documento = "";
    }

    this.errosValidacao = [];
    this.$utils.requestFocus("txtAutorizado");
  },
  data() {
    return {
      errosValidacao: [],
      loadingAutorizado: false,
      documento: "",
    };
  },
};
</script>

<style></style>
